import React from 'react';
import { ReactElement } from 'react';

import { Box } from '@qwealth/qcore';

import { ACTION_CONFIRMATION_EDIT, ActionConfirmationOptions } from 'data/models/Activity';
import { upperFirst } from 'lodash';

interface Props {
  action: ActionConfirmationOptions;
  taskTitle: string;
  note?: string | React.ReactElement;
}

const RecurringTaskActionConfirmationBodyText: React.FC<Props> = ({ action, taskTitle, note }): ReactElement => {
  const isEdit = action === ACTION_CONFIRMATION_EDIT;
  return (
    <Box display="flex" flexDirection="column" gap="default">
      <Box as="span">
        {isEdit ? (
          <>
            Are you sure you want to modify this task <b>"{upperFirst(taskTitle)}"</b>? Please confirm what you would like to modify from the below
            options:{' '}
          </>
        ) : (
          <>
            Are you sure you want to delete task <b>"{upperFirst(taskTitle)}"</b>? Please confirm what you would like to delete from the below
            options:{' '}
          </>
        )}
      </Box>
      <Box as="ul" display="flex" flexDirection="column" gap="default">
        <Box as="li">
          <b>This Task</b> - {isEdit ? 'Modify only this task.' : 'Delete only this task.'}
        </Box>
        <Box as="li">
          <b>All Tasks</b> -{' '}
          {isEdit ? 'Modify this task and all future occurrences of this task.' : 'Delete this task and all future occurrences of this task.'}
        </Box>
      </Box>
      {note && (
        <Box>
          <Box mb="default">
            <b>Note: </b>
          </Box>
          {typeof note === 'string' && <Box>{note}</Box>}
          {React.isValidElement(note) && note}
        </Box>
      )}
    </Box>
  );
};

export default RecurringTaskActionConfirmationBodyText;
